/**
 * @generated SignedSource<<451d979740d0c1ebf90bfb9d9947587e>>
 * @relayHash 7a5eb516ec34832f489c5bbcb425691f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0887b7686752645684b01a65b7aa3ee0e74d0adc0042efdd26ba713bce0a5d5

import type { ConcreteRequest } from 'relay-runtime';
export type GraphInferencePromoteInferredProjectInput = {
  inferredProjectAri: string;
};
export type usePromoteInferredProjectMutation$variables = {
  input: GraphInferencePromoteInferredProjectInput;
};
export type usePromoteInferredProjectMutation$data = {
  readonly graphInference_promoteInferredProject: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null;
      readonly message: string;
    }>;
    readonly project: {
      readonly ari: string;
      readonly url: string;
    } | null;
    readonly success: boolean;
  } | null;
};
export type usePromoteInferredProjectMutation = {
  response: usePromoteInferredProjectMutation$data;
  variables: usePromoteInferredProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphInferencePromoteInferredProjectPayload",
    "kind": "LinkedField",
    "name": "graphInference_promoteInferredProject",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphInferenceMutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "code"
          },
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "GraphInferencePromotedAtlasProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ari"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePromoteInferredProjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePromoteInferredProjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a0887b7686752645684b01a65b7aa3ee0e74d0adc0042efdd26ba713bce0a5d5",
    "metadata": {},
    "name": "usePromoteInferredProjectMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6642850ea612bc3eef52018c9a65eb87";

export default node;
